import { render } from "./DatabaseProductNew.vue?vue&type=template&id=0298367c"
import script from "./DatabaseProductNew.vue?vue&type=script&lang=js"
export * from "./DatabaseProductNew.vue?vue&type=script&lang=js"

import "./DatabaseProductNew.vue?vue&type=style&index=0&id=0298367c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__